import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

export const tableColumns = (handleAction) => [
    { dataField: "id", text: "ID", sort: true, headerStyle: { width: '80px' } },
    { dataField: "entity", text: "Client Name", sort: true },
    { dataField: "email", text: "Email", sort: true },
    { dataField: "created_at", text: "Created On", sort: true },
    { dataField: "amount", text: "Amount", sort: true },
    { dataField: "payment_mode", text: "Payment Mode", sort: true },
    {
        dataField: "status", text: "Status",
        formatter: (cell) => {
            let badgeClass = "bg-warning-subtle text-warning";
            if (cell === "Approved") badgeClass = "bg-success-subtle text-success";
            if (cell === "Rejected") badgeClass = "bg-danger-subtle text-danger";

            return (
                <span className={`badge rounded-pill ${badgeClass}`} style={{ fontSize: '11px', padding: '5px 10px' }}>
                    {cell}
                </span>
            );
        }
    },
    {
        dataField: "actions", text: "Action", headerClasses: "text-end px-4", classes: "text-end px-4", isDummyField: true,
        formatter: (_, row) => (
            <UncontrolledDropdown>
                <DropdownToggle tag="button" className="btn btn-light btn-sm border">
                    <i className="bx bx-dots-horizontal-rounded"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem onClick={() => handleAction("View", row)}>
                        <i className="bx bx-show-alt me-2 text-primary"></i> View
                    </DropdownItem>
                    <DropdownItem onClick={() => handleAction("Edit", row)}>
                        <i className="bx bx-download me-2 text-success"></i> Download
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="text-danger">
                        <i className="bx bx-trash me-2"></i> Delete
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        ),
    },
];